import apiClient from "./apiClient";
const resource = "/room-categories";
const priceResource = "/room-category-prices";


export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(data, uuid) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
  async search(keyword) {
    return apiClient.get(`${resource}/search?keyword=${keyword}`);
  },
  /* Price endpoints - use apiClient (consistent with other methods) */
  createPrice(payload) {
    return apiClient.post(`${priceResource}`, payload);
  },

  updatePrice(payload, uuid) {
    return apiClient.put(`${priceResource}/${uuid}`, payload);
  },

  deletePrice(uuid) {
    return apiClient.delete(`${priceResource}/${uuid}`);
  },
};
